import ToggleSidebarButton from "./ToggleSidebarButton";
import moment from 'jalali-moment';

export default function NavbarLeft() {
  return (
    <div className="flex items-center gap-4">
      <ToggleSidebarButton />
      <div className="text-sm">
        <span className="text-gray-400">امروز،</span>
        <span className="mx-1">{moment().locale('fa').format('dddd YYYY/MM/DD')}</span>
      </div>
    </div>
  );
}
